// extracted by mini-css-extract-plugin
export var actionButton = "ComponentCoverageLandingHeader-module--actionButton--f1067";
export var body = "ComponentCoverageLandingHeader-module--body--bfd6d";
export var buttonAndPrice = "ComponentCoverageLandingHeader-module--buttonAndPrice--00834";
export var conditions = "ComponentCoverageLandingHeader-module--conditions--a8dce";
export var copy = "ComponentCoverageLandingHeader-module--copy--e8b71";
export var ctaButton = "ComponentCoverageLandingHeader-module--ctaButton--ef812";
export var h1 = "ComponentCoverageLandingHeader-module--h1--51488";
export var image = "ComponentCoverageLandingHeader-module--image--0f895";
export var link = "ComponentCoverageLandingHeader-module--link--aa67d";
export var mediaWrapper = "ComponentCoverageLandingHeader-module--mediaWrapper--fa5f7";
export var p = "ComponentCoverageLandingHeader-module--p--73dfa";
export var priceIndicator = "ComponentCoverageLandingHeader-module--priceIndicator--83e41";
export var section = "ComponentCoverageLandingHeader-module--section--8b075";
export var text = "ComponentCoverageLandingHeader-module--text--704f1";
export var ul = "ComponentCoverageLandingHeader-module--ul--1fdeb";
export var uspItem = "ComponentCoverageLandingHeader-module--uspItem--60da4";
export var uspItemIcon = "ComponentCoverageLandingHeader-module--uspItemIcon--05ea8";
export var uspItemIconWrapper = "ComponentCoverageLandingHeader-module--uspItemIconWrapper--ec91d";
export var uspItemLabel = "ComponentCoverageLandingHeader-module--uspItemLabel--b2c88";
export var uspItemTrustpilot = "ComponentCoverageLandingHeader-module--uspItemTrustpilot--fe2f3";
export var uspItems = "ComponentCoverageLandingHeader-module--uspItems--5851e";
export var video = "ComponentCoverageLandingHeader-module--video--022b1";